import React, { useMemo, useState } from "react";
import { optionsType, responseType } from "../utils/formTypes";
import { FormAutocomplete, formClasses } from "../styles/AutocompleteStyles";
import { Avatar, Box, TextField } from "@mui/material";
import { Label } from "../stories/Label/Label";

interface Props {
  //   onKeyDown:
  //     | ((
  //         event: React.KeyboardEvent<HTMLDivElement> & {
  //           defaultMuiPrevented?: boolean;
  //         }
  //       ) => void)
  //     | undefined;
  onChange: (newValue: responseType) => void;
  //   value: string;
  //   label: string;
  //   placeholder?: string;
}

const IconSelect = ({
  onChange,
}: //   onKeyDown,
//   label,
//   placeholder,
//   value,
Props) => {
  const [value, setvalue] = useState("");
  const fileNames = [
    "360 deg Camera",
    "ALcometer",
    "Body Camera",
    "camera",
    "Desktop",
    "Drones",
    "Horizontal Signal",
    "Led Board",
    "SpeedCam",
    "Swiping Machine",
    "Tab",
    "Vertical Signal",
    "walkie talkie",
    "Warning Poles",
    "signals",
  ];

  let fileNames1 = fileNames;

  const icons: optionsType[] = useMemo(() => {
    return fileNames1.map((file) => {
      return {
        // label: require(`${process.env.React_App_Img_Icons1}/${file}.svg`),
        label: require(`../images/ItemIcons/${file}.svg`),

        value: file,
      };
    });
  }, []);

  return (
    <div className="label-grid">
      <Label>Select Icon</Label>
      <FormAutocomplete
        className={formClasses.inputRoot}
        options={icons}
        //   onKeyDown={(e) => {
        //     if (e.key === Keys.ENTER) {
        //       e.preventDefault();
        //       handleMUISelectEvent(e);
        //     }
        //   }}

        renderOption={(props, option) => {
          return (
            <Box component="li" {...props} display="flex" alignItems="center">
              <Avatar
                src={(option as optionsType).label}
                sx={{ marginRight: 2 }}
              />
            </Box>
          );
        }}
        openOnFocus
        forcePopupIcon
        onChange={(e, newValue) => {
          onChange(newValue as responseType);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            className={formClasses.formControlRoot}
            InputProps={{
              ...params.InputProps,
              startAdornment: value ? (
                <img
                  src={value}
                  // alt={value}
                  // sx={{
                  //   width: 40,
                  //   height: 40,
                  //   marginRight: 1,
                  // }}
                />
              ) : null,
            }}
          />
        )}
      />
    </div>
  );
};

export default IconSelect;
